// Nút chữ (UI_SPEC §10.1): không nền, không viền, gạch chân phát sáng. Đúng 1 nút primary mỗi hàng.
import type { ComponentChildren, JSX } from 'preact';

export type TextButtonVariant = 'primary' | 'ghost' | 'goto';

export function TextButton(props: {
  variant?: TextButtonVariant;
  onClick?: () => void;
  disabled?: boolean;
  id?: string;
  /** Nút bật / tắt: đọc thành aria-pressed. */
  pressed?: boolean;
  children: ComponentChildren;
}): JSX.Element {
  const v = props.variant ?? 'primary';
  return (
    <button
      type="button"
      class={v === 'primary' ? 'ht-textbtn' : `ht-textbtn ${v}`}
      data-id={props.id}
      aria-pressed={props.pressed}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}
